export const channelMarkerElement = (channel, allowSelectingChannel = false) => {
  return (
    `<div class="marker-element">
      <div class="marker-element-image">
        <img src="${channel.logo_url}" alt="${channel.title}" />
      </div>
      <a class="marker-element-title" target="_blank" href="/channels/${channel.id}" data-channel-id="${channel.id}">
        ${channel.title}
      </a>
      ${allowSelectingChannel ? selectChannelButton(channel) : ''}
    </div>`
  )
} 

export const selectChannelButton = (channel) => {
  return (
    `<button 
      class="select-channel-button primary button" 
      type="button" 
      data-channel-id="${channel.id}"
    >
      Select
    </button>`
  )
} 

export const selectedChannelIcon = (channel) => {
  return `
    <div class="selected-channel-icon text-center">
      <img 
        class="select-channel-logo" 
        src="${channel.logo_url}" 
        alt="${channel.title}"
      >
      <button 
        class="button mini unselect-channel-button" 
        type="button"
        data-channel-id="${channel.id}"
      >Clear</button>
    </div>
  `
}

export const markerByColor = (color="black") => {
  return window.L.icon({ 
    iconUrl: `/${color}-pin.svg`,
    iconSize: [40, 40],
    iconAnchor: [20, 35],
    popupAnchor: [1, -34]
  });
}